import ApiService from "@/core/services/api.service";


// export const GET_PAYMENT = (params) => {
//   return new Promise((resolve, reject) => {
//     ApiService.setHeader();
//     ApiService.query(`payment-types`, params)
//       .then(({ data }) => {
//         resolve(data);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };
export const GET_PAYMENT_LIST = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.query(`payment-types`, params)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const CREATE_PAYMENT = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.post("payment-types", params) 
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {  
        reject(error);
      });
  });
};
 

export const UPDATE_PAYMENT = (id, params) => {
  return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.put(`payment-types/${id}`, params)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const FIND_UTILITY_PAYMENT = (month,year) => {
  return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.get(`payment-types-details/?month=${month}&year=${year}`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
 

// function for new sales and profit repory
export const GET_SALES_REPORT = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.query(`sales-report`, params)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};